import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import {
  AlertDialogComponent,
  PropertyImageComponent,
  UploadFormComponent,
} from '@smart-flip/shared-components';
import { FeaturesPhotoCarouselModule } from '@smartflip/carousel';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    FeaturesPhotoCarouselModule,
    PropertyImageComponent,
    AlertDialogComponent,
    UploadFormComponent,
  ],
  exports: [PropertyImageComponent, UploadFormComponent, AlertDialogComponent],
})
export class SharedModule {}
